import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../Containers/Config/index.js';
import { GET_BOOKING_LIST, GET_BOOKING_LIST_SUCCESS, GET_BOOKING_LIST_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getBookingList({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/bookings`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        projectId: payload?.urlParam?.projectId,
        bookingTypeId: payload?.urlParam?.bookingTypeId,
        pageIndex: payload?.urlParam?.pageIndex,
        pageSize: Constant?.TABLE_PAGE_SIZE,
        sortOn: payload?.urlParam?.sortOn,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      // yield put({
      //   type: MAIN_AREA_LOADER_HIDE,
      // })

      yield put({
        type: GET_BOOKING_LIST_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_BOOKING_LIST_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_BOOKING_LIST_ERROR, payload: error });
  }
}

export function* watchBookingList() {
  yield takeEvery(GET_BOOKING_LIST, getBookingList);
}

function* bookingListSaga() {
  yield all([fork(watchBookingList)]);
}

export default bookingListSaga;
